import { render, staticRenderFns } from "./BuddyAsideWidget.vue?vue&type=template&id=0885c658&scoped=true"
import script from "./BuddyAsideWidget.vue?vue&type=script&lang=ts"
export * from "./BuddyAsideWidget.vue?vue&type=script&lang=ts"
import style0 from "./BuddyAsideWidget.vue?vue&type=style&index=0&id=0885c658&prod&lang=scss"
import style1 from "./BuddyAsideWidget.vue?vue&type=style&index=1&id=0885c658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885c658",
  null
  
)

export default component.exports